import styled from 'styled-components';
import Text from '../../../../../components/Text';
import Box from '../../../../../components/Box';

interface SummaryItemProps {
  label: string;
  value: string | number;
  icon: React.ReactNode;
}

const SummaryItem = ({ label, value, icon }: SummaryItemProps) => {
  return (
    <Container>
      <Box>
        <Text variant='BODY_2' color='text_2'>{label}</Text>
        <Text variant='H9' style={{ fontWeight: 'bold' }}>
          {value}
        </Text>
      </Box>
      {icon}
    </Container>
  );
};

export default SummaryItem;

const Container = styled.div`
  display: flex;
  padding: 8px 16px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  justify-content: space-between;
  align-items: center;


`;
